/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgAlertsDanger24(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='#BD2D00'
        fillRule='evenodd'
        d='M22.13 13.549c.862-.854.87-2.236.018-3.1l-8.55-8.66a2.234 2.234 0 00-1.59-.664c-.6 0-1.175.239-1.593.663-2.05 2.077-6.53 6.614-8.55 8.662a2.188 2.188 0 00.019 3.099l4.92 4.872.02.018 3.609 3.574a2.24 2.24 0 003.149 0l8.548-8.464zm-1.049-1.04l-8.55 8.465a.744.744 0 01-1.05 0l-5.98-5.921-2.569-2.543a.73.73 0 01-.005-1.033c2.02-2.048 6.5-6.585 8.55-8.662a.744.744 0 011.061 0l3.815 3.866.01.01.008.009c1.774 1.797 3.612 3.658 4.715 4.777a.728.728 0 01-.005 1.033zm-9.843-6.213a.1.1 0 00-.07.03.098.098 0 00-.028.07l.18 7.36h1.37l.097-7.36a.098.098 0 00-.098-.1h-1.45zm-.457 10.36a1.225 1.225 0 102.449-.001 1.225 1.225 0 00-2.45 0z'
      />
    </svg>
  );
}

export default SvgAlertsDanger24;
